import React, { PureComponent } from 'react'
import { graphql } from 'react-apollo'
import PropTypes from 'prop-types'
import Product from './features/product/Product'
import AppDetailsQuery from './queries/AppDetailsQuery'
import { LoanProvider } from '../shared/LoanContext'

class AppDetails extends PureComponent {
  get filteredProducts() {
    const {
      props: { data: { products = [] }, superUser }
    } = this

    let filteredProducts = products

    if (!superUser) {
      filteredProducts = products.filter(({ quickDraw }) => !quickDraw)
    }

    return filteredProducts
  }
  render() {
    const {
      props: { data: { loan, productSwitchReasons }, productName, customerService, partnerSettingsEnabled },
      filteredProducts
    } = this

    return (
      <LoanProvider value={loan}>
        <Product
          loan={loan}
          products={filteredProducts}
          productSwitchReasons={productSwitchReasons}
          productName={productName}
          customerService={customerService}
          partnerSettingsEnabled={partnerSettingsEnabled}
        />
      </LoanProvider>
    )
  }
}

export {
  AppDetails
}

AppDetails.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.object,
    loan: PropTypes.shape({
      amount: PropTypes.number.isRequired,
      product: PropTypes.object.isRequired
    })
  }),
  loanId: PropTypes.number.isRequired,
  productName: PropTypes.string,
  customerService: PropTypes.bool,
  superUser: PropTypes.bool
}

export default graphql(AppDetailsQuery, {
  options: ({ loanId }) => ({
    variables: {
      loanId,
      productsCategory: ['working_capital', 'cre', 'paycheck_protection']
    }
  })
})(AppDetails)
